<script setup lang="ts">
import { onMounted } from 'vue';
import imgPhone from '../../assets/img/checkout-welcome-phone.webp';
import imgTirzepatide from '../../assets/img/checkout-welcome-tirzepatide.webp';
import videoDoctor from '../../assets/video/checkout-welcome-doctor.mp4';

const emit = defineEmits<{
  'next': [];
}>();

onMounted(() => {
  setTimeout(() => emit('next'), 4700);
});
</script>

<template>
  <div class="pointer-events-none fixed inset-0 flex overflow-hidden py-[98px] lg:py-[124px]">
    <div class="fade relative m-auto flex h-[400px] w-full max-w-[1336px] md:h-full md:max-h-[734px]">
      <figure class="slide-left-1 absolute right-[-8%] top-0 w-[62%] max-w-[553px] md:right-40 md:w-[42%]">
        <video
          class="w-full rounded-[10px] shadow"
          muted
          loop
          autoplay
          playsinline
        >
          <source
            :src="videoDoctor"
            type="video/mp4"
          >
        </video>
      </figure>

      <figure class="slide-left-2 absolute left-[-8%] top-[20%] w-[48%] max-w-[363px] md:left-40 md:top-[14%] md:w-[28%]">
        <img
          class="w-full rounded-[10px] shadow"
          :src="imgTirzepatide"
          alt=""
        >
      </figure>

      <figure class="slide-left-3 absolute inset-x-0 left-[-14%] top-[53%] z-[-1] mx-auto w-[44%] max-w-[313px] md:w-[24%]">
        <img
          class="w-full rounded-[10px] shadow"
          :src="imgPhone"
          alt=""
        >
      </figure>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.shadow {
  box-shadow: 0px -2.86px 7.18px -2px #8B878407,
    0px -0.89px 9.91px -2px #8B87840B,
    0px 5.55px 11.88px -2px #8B87840D,
    0px 16.09px 16.76px -2px #8B878410,
    0px 30.36px 28.24px -2px #8B878413,
    0px 48px 50px -2px #8B87841A;
}

// Fade animation
.fade {
  animation: fade 5s linear both;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

// Slide left 1 animation
.slide-left-1 {
  animation: slide-1 5s linear both;
}

@keyframes slide-1 {
  from {
    transform: translateX(18%);
  }
  to {
    transform: translateX(-18%);
  }
}

// Slide left 2 animation
.slide-left-2 {
  animation: slide-2 5s linear both;
}

@keyframes slide-2 {
  from {
    transform: translateX(22%);
  }
  to {
    transform: translateX(-22%);
  }
}

// Slide left 3 animation
.slide-left-3 {
  animation: slide-3 5s linear both;
}

@keyframes slide-3 {
  from {
    transform: translateX(10%);
  }
  to {
    transform: translateX(-10%);
  }
}
</style>
